import { ApiHelper, AuthHelper } from '../helpers';

import axios from 'axios';
import { useAuth } from '.';

function useAuthAxios() {
  const { user, authenticated, setAuthenticated, setUser } = useAuth();

  if (authenticated) {
    const instance = axios.create({
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
      },
    });

    instance.interceptors.request.use(async function (config) {
      if (AuthHelper.isTokenExpired(user?.access_token)) {
        try {
          const responseRefreshToken = await axios(ApiHelper.getUrl.apiSCE.token(), {
            method: 'GET',
            params: {
              codigo: user?.refresh_token,
              tipo: 'REFRESH_TOKEN',
              url: process.env.REACT_APP_REDIRECT_URL,
            },
          });
          const responseUser = responseRefreshToken.data;
          setUser(responseUser);
          sessionStorage.setItem('user', JSON.stringify(responseUser));
          if (config.headers) {
            config.headers.Authorization = `Bearer ${responseUser.refresh_token}`;
          }
        } catch (error) {
          setUser(undefined);
          setAuthenticated(false);
          sessionStorage.removeItem('user');
        }
      }
      return config;
    });
    return instance;
  } else {
    return axios.create();
  }
}

export default useAuthAxios;
